import { v4 as uuid } from "uuid"

const uniqueId = (prefix) => {
  return prefix + uuid().slice(0, 8)
}

export default uniqueId
